<template>
	<div>
		<information-card
			sub-title="CÓMO GENERAR EL ORGANIGRAMA"
			title="MODELO DIRECTRIZ"
			class='full-section-height'
		>
			<div slot="content">
				<ol class="guide-steps">
					<li class="guide-step">
						<span class="step-number">1</span>
						<div class="step-text">
							<span class="step-title">Selecciona el puesto principal</span>
							<span class="step-desc">Haz clic en el puesto que deseas configurar.</span>
						</div>
					</li>
					<li class="guide-step">
						<span class="step-number">2</span>
						<div class="step-text">
							<span class="step-title">Elige los puestos subordinados</span>
							<span class="step-desc">Marca los puestos que dependerán del principal.</span>
						</div>
					</li>
					<li class="guide-step">
						<span class="step-number">3</span>
						<div class="step-text">
							<span class="step-title">Confirma la selección</span>
							<span class="step-desc">Haz clic en Cerrar para guardar.</span>
						</div>
					</li>
					<li class="guide-step">
						<span class="step-number">4</span>
						<div class="step-text">
							<span class="step-title">Genera el organigrama</span>
							<span class="step-desc">Presiona el botón al final de la pantalla.</span>
						</div>
					</li>
				</ol>
			</div>
			<div slot="footer" class="tw-text-center">
				<v-btn
					:disabled="disabled"
					class="custom-button tw-px-8"
					color="primary"
					@click="$emit('generate-hierarchy-click')"
					>Asignar Jerarquía</v-btn
				>
				<p v-if="disabled" class="tw-mt-2 tw-mb-0">
					Configura al menos un puesto de trabajo para continuar
				</p>
			</div>
		</information-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { find, pathOr, pipe, prop, propEq } from 'ramda';
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'guideline-model-instructions',
	components: { InformationCard },
	props: {
		disabled: { type: Boolean, default: true },
	},
	computed: {
		...mapState('jobEvaluation', {
			description: pipe(
				pathOr([], ['mainData', 'config', 'stages', 0, 'details']),
				find(propEq('goTo', 'job-supply-guideline-model')),
				prop('instructions'),
			),
		}),
	},
};
</script>

<style lang='scss' scoped>
.content-factors {
	width: 100% !important;
	position: relative !important;
	top: 0 !important;
}

.guide-steps {
	list-style: none;
	padding: 0;
	margin: 0;
}

.guide-step {
	display: flex;
	align-items: flex-start;
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.step-number {
	flex-shrink: 0;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	border: 2px solid var(--app-color-primary);
	color: var(--app-color-primary);
	font-size: 12px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px;
	margin-top: 2px;
}

.step-text {
	display: flex;
	flex-direction: column;
}

.step-title {
	color: var(--app-color-info);
	font-weight: bold;
	font-size: 14px;
	line-height: 1.4;
}

.step-desc {
	color: #969696;
	font-size: 13px;
	line-height: 1.4;
	margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-model-instructions.vue